import { render, staticRenderFns } from "./FamilyHistoryList.vue?vue&type=template&id=3e92f238&lang=pug"
import script from "./FamilyHistoryList.vue?vue&type=script&lang=ts"
export * from "./FamilyHistoryList.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports